/* eslint-disable no-nested-ternary */

// Default styles for react-select
export const REACT_SELECT_STYLES = {
  control: (provided, thisState) => {
    return {
      ...provided,
      '&:hover': {
        borderColor: thisState.isFocused
          ? 'var(--cc_color_border_input_active)'
          : 'var(--cc_color_border_input_inactive)',
        cursor: 'pointer',
      },
      borderColor: thisState.isFocused
        ? 'var(--cc_color_border_input_active)'
        : 'var(--cc_color_border_input_inactive)',
      boxShadow: thisState.isFocused ? `0` : null,
      minHeight: 50,
      borderRadius: 'var(--cc_size_border_radius_l)',
    };
  },
  input: (provided) => {
    return {
      ...provided,
      color: 'var(--cc_color_text_default)',
    };
  },
  option: (provided, { isDisabled, isFocused, isSelected }) => {
    return {
      ...provided,
      padding: '12px 16px',
      backgroundColor: isDisabled
        ? null
        : isSelected
        ? 'var(--cc_color_background_2)'
        : isFocused
        ? 'var(--cc_color_brand_primary)'
        : null,
      color: isDisabled
        ? 'var(--cc_color_text_nonessential'
        : isFocused && !isSelected
        ? 'white'
        : 'var(--cc_color_text_default)',
      cursor: isDisabled ? 'not-allowed' : 'pointer',
      ':active': {
        ...provided[':active'],
        backgroundColor:
          !isDisabled &&
          (isSelected
            ? 'var(--cc_color_background_2)'
            : 'var(--cc_color_brand_primary)'),
      },
    };
  },
  multiValue: (provided) => {
    return {
      ...provided,
      boxSizing: 'border-box',
      backgroundColor: 'var(--cc_color_background_1)',
      border: `1px solid var(--cc_color_border_input_inactive)`,
      borderRadius: '30px',
      padding: '4px 4px 4px 10px',
    };
  },
  multiValueLabel: (provided) => ({
    ...provided,
    color: 'var(--cc_color_text_subtle)',
    fontSize: '13px',
    padding: '0px',
    paddingLeft: '0px',
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    color: 'var(--cc_color_text_subtle)',
    ':hover': {
      backgroundColor: 'transparent',
      color: 'var(--cc_color_text_default)',
      cursor: 'pointer',
    },
  }),
};

export const PROJECT_FORM_SELECT_STYLES = {
  control: (provided, thisState) => {
    return {
      ...provided,
      '&:hover': {
        borderColor: thisState.isFocused
          ? 'var(--cc_color_border_input_active)'
          : 'var(--cc_color_button_background_secondary)',
      },
      borderRadius: 'var(--cc_size_border_radius_l)',
      fontSize: 'var(--cc_size_text_s)',
    };
  },
  placeholder: (provided) => {
    return {
      ...provided,
      color: 'var(--cc_color_text_nonessential)',
      fontWeight: '500',
      fontSize: 'calc(var(--cc_size_text_s)',
    };
  },
};

export const USER_SELECT_STYLES = {
  control: (provided, thisState) => {
    return {
      ...provided,
      '&:hover': {
        borderColor: thisState.isFocused
          ? 'var(--cc_color_border_input_active)'
          : 'var(--cc_color_border_input_inactive)',
      },
      borderColor: thisState.isFocused
        ? 'var(--cc_color_border_input_active)'
        : 'var(--cc_color_border_input_inactive)',
      boxShadow: thisState.isFocused
        ? '0 0 0 var(--cc_size_border_width_s) var(--cc_color_border_input_active)'
        : null,
      minHeight: 40,
      borderRadius: 'var(--cc_size_border_radius_pill)',
      fontSize: 'var(--cc_size_text_s)',
      paddingInlineStart: 'var(--cc_size_spacing_s)',
    };
  },
  menuPortal: (provided) => ({ ...provided, zIndex: 9999 }),
};
/* eslint-enable no-nested-ternary */
